export const API_ERRORS = {
  tooManyAttempts: 'Too many attempts. Please try again later.',
  csrfMismatch: 'CSRF token mismatch. Please refresh the page.',
};
